module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('nav', {
    staticClass: "navbar navbar-ct-default",
    attrs: {
      "role": "navigation-demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Site title")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navigation-example-2"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "footer-demo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navigation-example-2"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-full-page section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("404 Not Found")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Wygląda na to, że ta strona nie istnieje")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n        © 2017, made with\n        "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by Paper admin\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27db2b6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeneralViews/NotFoundPage.vue
// module id = 438
// module chunks = 1